import { LoadingContainer } from 'peach/components'
import { useHistory, useParams } from 'peach/router'

import { CreateForm } from 'core/components/lib/DynamicForm'
import { Page } from 'core/components/lib/Page'
import PageHeader from 'core/components/lib/PageHeader'
import {
  useInternalCompanyApiKeyCreate,
  RequestBodyAPIKeyNoSecretAPIVersioning,
} from 'core/types'
import { InternalCompanyApiKeyCreateResponse } from 'core/types/operations'
import { keysRequestSchema } from 'core/utils/generated/formSchemas'

import { apiKeyCreateRules, apiKeyFieldOverrides } from './apiKeyFormRules'

const CreateAPIKey = () => {
  const history = useHistory()
  const { companyId } = useParams<{ companyId?: string }>()

  const { mutateAsync: createApiKey } = useInternalCompanyApiKeyCreate({
    companyId,
  })

  return (
    <LoadingContainer>
      <Page variant='full'>
        <PageHeader title='Create API Key' />
        <CreateForm
          fieldOverrides={apiKeyFieldOverrides}
          onSubmit={async (payload) => {
            const res = (await createApiKey(
              payload as RequestBodyAPIKeyNoSecretAPIVersioning,
            )) as unknown as {
              status: number
              data: InternalCompanyApiKeyCreateResponse
            }
            const id = res?.data?.id
            if (id) {
              history.push(`/companies/${companyId}/api-keys/${id}`)
            }
          }}
          schema={keysRequestSchema}
          submitText='Create API Key'
          validationRules={apiKeyCreateRules}
        />
      </Page>
    </LoadingContainer>
  )
}

export default CreateAPIKey
